import React from "react"

export default function Moon({ enable }) {
  return (
    <img src={require("../images/sun-moon.svg")} className="icon" alt="moon" />
  )
}
